(function() {
  const redirects = {
    'https://www.rambobikes.com/collections/battery-upgrades': 'https://www.rambobikes.com/',
    'https://www.rambobikes.com/pages/hiring/careers': 'https://www.rambobikes.com/',
  };

  const currentURL = window.location.origin + window.location.pathname;

  if (redirects[currentURL]) {
    const qs = window.location.search + window.location.hash;
    window.location.replace(redirects[currentURL] + qs);
  }
})();




